import { ContentSection, Secondary } from '@cinch-labs/design-system'
import { storyblokEditable } from '@cinch-nx/data-storyblok'
import renderWithResolver from '@cinch-nx/landing-ui-shared/lib/rich-text-renderer/rich-text-renderer'
import {
  EventActions,
  EventCategories,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

import type { HelpMeChooseSection as HelpMeChooseProps } from '../../types/our-commitment-page'
import styles from './help-me-choose.module.css'

export const HelpMeChoose: React.FC<HelpMeChooseProps> = (blok) => {
  const { title, body, buttonLabel } = blok
  const { trackEvent } = useAnalytics()

  return (
    <section {...storyblokEditable(blok)} className={styles.container}>
      <ContentSection
        title={title}
        classNames={{ title: styles.title }}
        sectionWrapperClass={styles.contentSectionWrapper}
      >
        {renderWithResolver(body)}
      </ContentSection>
      <Secondary
        classNames={{ button: styles.button }}
        element="a"
        href="/help-me-choose/most-important"
        onClick={() => {
          trackEvent({
            eventName: `Our commitment - ${buttonLabel}`,
            data: {
              event: {
                name: EventActions.click,
                category: EventCategories.button,
                label: buttonLabel,
              },
            },
            type: TrackingEventTypes.ADOBE,
          })
        }}
      >
        {buttonLabel}
      </Secondary>
    </section>
  )
}
